// extracted by mini-css-extract-plugin
export default {"EmptyPlaceholder":"EmptyPlaceholder_EmptyPlaceholder__q8HbJ"};